import React, {Component} from 'react'
import '../../styles/Admin.css'
import {Tab, Tabs} from "react-bootstrap-tabs";
import EdytujEvent from "./eventyComponents/EdytujEvent";
import NowyEvent from "./eventyComponents/NowyEvent";
import ZarzadzanieEventami from "./eventyComponents/ZarzadzanieEventami";
import AdminPanel from "../AdminPanel";
// import '../../styles/Tabs.css'

export default class AdminEventy extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedItem: '',
            title: '',
            selectedIndex: 0
        }
    }

    render() {
        return <AdminPanel>
            <div className="componentContainer">
                <h5 style={{paddingLeft: 10}}>Eventy</h5>
                <hr/>
                <Tabs selected={this.state.selectedIndex} onSelect={(index, label) => {
                    this.setState({selectedIndex: index});
                }}>
                    <Tab label={'Zarządzanie eventami'}>
                        <ZarzadzanieEventami goNowyWpis={() => this.setState({selectedIndex: 1})}
                                             goEdycja={() => this.setState({selectedIndex: 2})}
                                             setItem={(item) => this.setState({
                                                 selectedItem: item,
                                                 title: item.tytul
                                             })}/>
                    </Tab>
                    <Tab label={'Dodaj event'}>
                        <NowyEvent goZarzadzanie={() => this.setState({selectedIndex: 0})}/>
                    </Tab>
                    <Tab label={this.state.title} disabled={this.state.selectedIndex !== 2}>
                        <EdytujEvent item={this.state.selectedItem}
                                     goZarzadzanie={() => this.setState({selectedIndex: 0})}/>
                    </Tab>
                </Tabs>
            </div>
        </AdminPanel>
    }

}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/AdminEventy.js